import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { MemberInstrument_Entity } from "../../entities/memberInstrument";

const memberInstrumentsAdapter = createEntityAdapter<MemberInstrument_Entity>();
const initialState = memberInstrumentsAdapter.getInitialState();

export const memberInstrumentEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getMemberInstruments: build.query<
      EntityState<MemberInstrument_Entity>,
      void
    >({
      query: () => `memberInstruments`,
      transformResponse: (responseData: MemberInstrument_Entity[]) => {
        return memberInstrumentsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["memberInstruments"],
    }),
    getMemberInstrument: build.query<MemberInstrument_Entity, number>({
      query: (id) => `memberInstruments/${id}`,
      providesTags: (result, error, id) => [{ type: "memberInstruments", id }],
    }),
    createMemberInstrument: build.mutation<
      MemberInstrument_Entity,
      Partial<MemberInstrument_Entity>
    >({
      query: (body) => ({
        method: "POST",
        body,
        url: `memberInstruments`,
      }),
      invalidatesTags: ["memberInstruments"],
    }),
    updateMemberInstrument: build.mutation<
      void,
      { id: number; body: Partial<MemberInstrument_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `memberInstruments/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "memberInstruments", id },
        "memberInstruments",
      ],
    }),
    deleteMemberInstrument: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `memberInstruments/${id}`,
      }),
      invalidatesTags: ["memberInstruments"],
    }),
  }),
});

export const {
  useGetMemberInstrumentQuery,
  useGetMemberInstrumentsQuery,
  useCreateMemberInstrumentMutation,
  useDeleteMemberInstrumentMutation,
  useUpdateMemberInstrumentMutation,
} = memberInstrumentEndpoints;

export default memberInstrumentEndpoints;
